import * as ge from "@arcgis/core/geometry/operators/unionOperator";
import { createLogger as ae } from "@origo/logger";
import * as ke from "@arcgis/core/geometry/operators/areaOperator";
import * as be from "@arcgis/core/geometry/operators/intersectionOperator";
import * as Re from "@arcgis/core/geometry/operators/intersectsOperator";
import Ae from "@arcgis/core/layers/support/CodedValueDomain";
import de from "@arcgis/core/request";
import Ne from "@arcgis/core/rest/support/FeatureSet";
import Ee from "@arcgis/core/layers/FeatureLayer";
import { queryOptions as O, useQuery as F } from "@tanstack/react-query";
import { jsx as Ie } from "react/jsx-runtime";
import { createContext as Oe, useMemo as Fe, useContext as oe } from "react";
function Se(e) {
  const r = `${e.planTypeKey}-${e.planStat ?? ""}-${e.vertNiv ?? ""}`;
  return e.planId ? `${r}-${e.planId}` : `${r}--oid:${e.objectId ?? ""}`;
}
function me(e) {
  const r = /* @__PURE__ */ new Map(), n = [];
  for (const t of e) {
    if (!t.planId) {
      n.push(t);
      continue;
    }
    const a = `${t.planTypeKey}|${t.planStat ?? ""}|${t.vertNiv ?? ""}|${t.planId}`, o = r.get(a);
    o ? o.push(t) : (r.set(a, [t]), n.push(a));
  }
  return n.map(
    (t) => typeof t == "string" ? Pe(r.get(t)) : t
  );
}
function Pe(e) {
  const r = [
    ...new Set(e.flatMap((t) => t.objectIds ?? (t.objectId != null ? [t.objectId] : [])))
  ].sort((t, a) => t - a);
  return e.length === 1 ? r.length > 0 ? { ...e[0], objectIds: r } : e[0] : { ...e.reduce(
    (t, a) => (a.objectId ?? 1 / 0) < (t.objectId ?? 1 / 0) ? a : t
  ), objectIds: r };
}
class M extends Error {
  constructor(r, n) {
    super(r), this.cause = n, this.name = this.constructor.name;
  }
}
class ve extends M {
  constructor(r, n) {
    super(`${r} ikke funnet: ${n}`);
  }
}
class Te extends M {
}
class C extends M {
}
class he extends M {
}
class J extends M {
  constructor() {
    super("Operasjonen ble avbrutt");
  }
}
class H extends M {
}
const Ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: J,
  ArealplanError: M,
  AuthError: he,
  ConfigurationError: H,
  NetworkError: C,
  NotFoundError: ve,
  ValidationError: Te,
  mergePlanomrader: me,
  planKey: Se
}, Symbol.toStringTag, { value: "Module" })), ie = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function X(e) {
  try {
    return Math.abs(ke.execute(e, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function ce(e, r, n = {}) {
  if (!e || !r)
    return { keep: !0, reason: "missing-geometry" };
  const t = n.minAreaM2 ?? ie.minAreaM2, a = n.minRatio ?? ie.minRatio, o = e.spatialReference?.wkid, i = r.spatialReference?.wkid;
  if (o != null && i != null && o !== i)
    return { keep: !0, reason: "sr-mismatch", srcWkid: o, candWkid: i };
  const s = e, R = r;
  try {
    if (!Re.execute(s, R))
      return { keep: !1, reason: "no-intersect", srcWkid: o, candWkid: i };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: o, candWkid: i };
  }
  let m;
  try {
    m = be.execute(s, R);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: o, candWkid: i };
  }
  if (!m)
    return o != null && i != null && o === i ? { keep: !1, reason: "touch-no-area", srcWkid: o, candWkid: i, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: o, candWkid: i };
  const K = X(m), h = X(e), v = X(r), U = Math.min(h, v), Q = U > 0 ? K / U : 0, l = { srcWkid: o, candWkid: i, overlapAreaM2: K, sourceAreaM2: h, candidateAreaM2: v, ratio: Q };
  return Q >= a ? { keep: !0, reason: "ratio-pass", ...l } : K >= t ? { keep: !0, reason: "area-pass", ...l } : { keep: !1, reason: "below-threshold", ...l };
}
function se(e, r, n = {}) {
  return ce(e, r, n).keep;
}
const Be = /^(Kommuneplan|Kommunedelplan|Reguleringsplan|Bebyggelsesplan)/i, je = /^Dispensasjon/i, Le = /^PblMidlForbud/i, ne = {
  // Reguleringsplan (Rp-prefiks) — arealformål
  RpArealformålOmråde: {
    canonical: "RpArealformålOmråde",
    aliases: ["RpArealformålOmråde", "RpArealformalOmrade", "RpArealformaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "RPAREALFORMAL"
  },
  RpBestemmelseOmråde: {
    canonical: "RpBestemmelseOmråde",
    aliases: ["RpBestemmelseOmråde", "RpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "RPBESTEMMELSEHJEMMEL"
  },
  RpAngittHensynSone: {
    canonical: "RpAngittHensynSone",
    aliases: ["RpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPANGITTHENSYN"
  },
  RpBåndleggingSone: {
    canonical: "RpBåndleggingSone",
    aliases: ["RpBåndleggingSone", "RpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPBANDLEGGING"
  },
  RpDetaljeringSone: {
    canonical: "RpDetaljeringSone",
    aliases: ["RpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPDETALJERING"
  },
  RpFareSone: {
    canonical: "RpFareSone",
    aliases: ["RpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPFARE"
  },
  RpGjennomføringSone: {
    canonical: "RpGjennomføringSone",
    aliases: ["RpGjennomføringSone", "RpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPGJENNOMFORING"
  },
  RpInfrastrukturSone: {
    canonical: "RpInfrastrukturSone",
    aliases: ["RpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPINFRASTRUKTUR"
  },
  RpSikringSone: {
    canonical: "RpSikringSone",
    aliases: ["RpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSIKRING"
  },
  RpStøySone: {
    canonical: "RpStøySone",
    aliases: ["RpStøySone", "RpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSTOY"
  },
  // Reguleringsplan/Bebyggelsesplan etter gammel lov (Rb-prefiks)
  RbArealbrukOmråde: {
    canonical: "RbArealbrukOmråde",
    aliases: ["RbArealbrukOmråde", "RbArealbrukOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFormålOmråde: {
    canonical: "RbFormålOmråde",
    aliases: ["RbFormålOmråde", "RbFormalOmrade", "RbFormaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbBevaringOmråde: {
    canonical: "RbBevaringOmråde",
    aliases: ["RbBevaringOmråde", "RbBevaringOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFareOmråde: {
    canonical: "RbFareOmråde",
    aliases: ["RbFareOmråde", "RbFareOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFornyelseOmråde: {
    canonical: "RbFornyelseOmråde",
    aliases: ["RbFornyelseOmråde", "RbFornyelseOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRekkefølgeOmråde: {
    canonical: "RbRekkefølgeOmråde",
    aliases: ["RbRekkefølgeOmråde", "RbRekkefolgeOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRestriksjonOmråde: {
    canonical: "RbRestriksjonOmråde",
    aliases: ["RbRestriksjonOmråde", "RbRestriksjonOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  // Kommuneplan / Kommunedelplan (Kp-prefiks) — arealformål
  KpArealformålOmråde: {
    canonical: "KpArealformålOmråde",
    aliases: ["KpArealformålOmråde", "KpArealformalOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "KPAREALFORMAL"
  },
  KpArealbrukOmråde: {
    canonical: "KpArealbrukOmråde",
    aliases: ["KpArealbrukOmråde", "KpArealbrukOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "OPLAREAL"
  },
  KpBestemmelseOmråde: {
    canonical: "KpBestemmelseOmråde",
    aliases: ["KpBestemmelseOmråde", "KpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "KPBESTEMMELSEHJEMMEL"
  },
  KpRestriksjonOmråde: {
    canonical: "KpRestriksjonOmråde",
    aliases: ["KpRestriksjonOmråde", "KpRestriksjonOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRESTR"
  },
  KpRetningslinjeOmråde: {
    canonical: "KpRetningslinjeOmråde",
    aliases: ["KpRetningslinjeOmråde", "KpRetningslinjeOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRETNL"
  },
  KpAngittHensynSone: {
    canonical: "KpAngittHensynSone",
    aliases: ["KpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPANGITTHENSYN"
  },
  KpBåndleggingSone: {
    canonical: "KpBåndleggingSone",
    aliases: ["KpBåndleggingSone", "KpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPBANDLEGGING"
  },
  KpDetaljeringSone: {
    canonical: "KpDetaljeringSone",
    aliases: ["KpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPDETALJERING"
  },
  KpFareSone: {
    canonical: "KpFareSone",
    aliases: ["KpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPFARE"
  },
  KpGjennomføringSone: {
    canonical: "KpGjennomføringSone",
    aliases: ["KpGjennomføringSone", "KpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPGJENNOMFORING"
  },
  KpInfrastrukturSone: {
    canonical: "KpInfrastrukturSone",
    aliases: ["KpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPINFRASTRUKTUR"
  },
  KpSikringSone: {
    canonical: "KpSikringSone",
    aliases: ["KpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSIKRING"
  },
  KpStøySone: {
    canonical: "KpStøySone",
    aliases: ["KpStøySone", "KpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSTOY"
  },
  // PBL midlertidig (Pbl-prefiks)
  PblMidlByggAnleggOmråde: {
    canonical: "PblMidlByggAnleggOmråde",
    aliases: ["PblMidlByggAnleggOmråde", "PblMidlByggAnleggOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "OBJTYPE"
  }
}, Z = Array.from(
  new Set(Object.values(ne).flatMap((e) => e.aliases))
);
function _(e) {
  if (!e)
    return;
  const r = ne[e];
  if (r)
    return r;
  for (const n of Object.values(ne))
    if (n.aliases.includes(e))
      return n;
}
const x = {
  Reguleringsplan: ["RpOmrade"],
  Bebyggelsesplan: ["RpOmrade"],
  Kommuneplan: ["KpOmrade"],
  Kommunedelplan: ["KpOmrade"],
  Dispensasjon: ["DispensasjonPunkt"],
  PblMidlForbud: ["PblMidlForbudMotTiltakFlate"]
};
function ee(e) {
  if (x[e])
    return x[e];
  const r = e.replace(/(_UA)?(_VN\d+)?$/, "");
  if (x[r])
    return x[r];
  for (const [n, t] of Object.entries(x))
    if (e.includes(n))
      return t;
  return [];
}
const Me = {
  PLANID: "planId",
  LOKALID: "lokalId",
  GlobalID: "globalId",
  OBJECTID: "objectId",
  PLANNAVN: "planNavn",
  PLANSTAT: "planStat",
  PLANTYPE: "planTypeKey",
  VERTNIV: "vertNiv",
  IKRAFT: "ikraft",
  BESKRIVELSE: "beskrivelse",
  KOMMUNENUMMER: "kommunenummer",
  PLANBEST: "planBestemmelser",
  LOVREFERANSE: "lovreferanse",
  PLANREGISTERLINK: "planRegisterLink"
};
function Ke(e) {
  const r = {};
  if (e)
    for (const [n, t] of Object.entries(e)) {
      const a = Me[n];
      a && t != null && (r[a] = String(t));
    }
  return Object.keys(r).length > 0 ? r : void 0;
}
function le(e, r, n) {
  const t = e.OBJECTID != null ? Number(e.OBJECTID) : void 0;
  return {
    planId: String(e.PLANID ?? ""),
    lokalId: e.LOKALID ?? void 0,
    globalId: e.GlobalID ?? void 0,
    objectId: t,
    objectIds: t != null ? [t] : void 0,
    planTypeKey: r,
    planNavn: e.PLANNAVN ?? void 0,
    planStat: e.PLANSTAT ?? void 0,
    vertNiv: e.VERTNIV ?? void 0,
    ikraft: e.IKRAFT ?? void 0,
    beskrivelse: e.BESKRIVELSE ?? void 0,
    kommunenummer: e.KOMMUNENUMMER ?? void 0,
    planBestemmelser: e.PLANBEST ?? void 0,
    lovreferanse: e.LOVREFERANSE ?? void 0,
    planRegisterLink: e.PLANREGISTERLINK ?? void 0,
    displayValues: Ke(n)
  };
}
function we(e) {
  if (typeof e.LOKALID == "string" && e.LOKALID.trim() !== "")
    return e.LOKALID.trim();
  if (typeof e.GlobalID == "string" && e.GlobalID.trim() !== "")
    return e.GlobalID.trim();
  const r = e.OBJTYPE, n = e.OBJECTID;
  if (typeof r == "string" && r.trim() !== "" && n != null)
    return `${r.trim()}-${n}`;
}
function De(e) {
  const r = _(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.typeFelt];
  return n == null ? void 0 : String(n);
}
function Ge(e, r) {
  const n = _(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!n)
    return;
  const t = r[n.typeFelt];
  return t == null ? void 0 : String(t);
}
function xe(e) {
  const r = _(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.headingFelt];
  return n == null ? void 0 : String(n);
}
function re(e, r, n, t) {
  return {
    omradeId: we(e),
    planId: String(e.PLANID ?? ""),
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    objtype: typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0,
    arealformål: De(e),
    arealformålDisplay: Ge(e, n),
    feltnavn: xe(e),
    geometri: r,
    planTypeKey: t,
    attributter: { ...e },
    displayValues: n
  };
}
const $e = {
  OBJECTID: "objectId",
  planId: "planId",
  pbltiltak: "pblTiltak",
  beskrivelse: "beskrivelse",
  dispensasjonType: "dispensasjonType",
  vedtaksdato: "vedtaksdato",
  tiltaksnr: "tiltaksnr",
  dispFra: "dispFra",
  vedtakId: "vedtakId",
  vedtak: "vedtak",
  sak_id: "sakId",
  sak_sakAar: "sakAar",
  sak_sakSeknr: "sakSeknr",
  sak_arkivId: "sakArkivId",
  sak_url: "sakUrl",
  sak_urlIntern: "sakUrlIntern",
  vedtak_urlEkstern: "vedtakUrlEkstern"
};
function qe(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const a = $e[n];
    r[a ?? n] = t;
  }
  return r;
}
function _e(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planId: typeof e.planId == "string" ? e.planId : void 0,
    planTypeKey: t,
    pblTiltak: typeof e.pbltiltak == "string" ? e.pbltiltak : void 0,
    beskrivelse: typeof e.beskrivelse == "string" ? e.beskrivelse : void 0,
    dispensasjonType: typeof e.dispensasjonType == "string" ? e.dispensasjonType : void 0,
    vedtaksdato: e.vedtaksdato ?? void 0,
    tiltaksnr: typeof e.tiltaksnr == "string" ? e.tiltaksnr : void 0,
    dispFra: typeof e.dispFra == "string" ? e.dispFra : void 0,
    vedtakId: typeof e.vedtakId == "string" ? e.vedtakId : void 0,
    vedtak: typeof e.vedtak == "string" ? e.vedtak : void 0,
    sakId: typeof e.sak_id == "string" ? e.sak_id : void 0,
    sakAar: e.sak_sakAar ?? void 0,
    sakSeknr: e.sak_sakSeknr ?? void 0,
    sakArkivId: typeof e.sak_arkivId == "string" ? e.sak_arkivId : void 0,
    sakUrl: typeof e.sak_url == "string" ? e.sak_url : void 0,
    sakUrlIntern: typeof e.sak_urlIntern == "string" ? e.sak_urlIntern : void 0,
    vedtakUrlEkstern: typeof e.vedtak_urlEkstern == "string" ? e.vedtak_urlEkstern : void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: qe(n)
  };
}
const Ve = {
  OBJECTID: "objectId",
  PBLTILTAKFORBUDTYPE: "tiltakforbudType",
  INFORMASJON: "informasjon",
  AVGJDATO: "avgjørelsesdato",
  GYLDIGTILDATO: "gyldigTilDato",
  FORSTEDIGITALISERINGSDATO: "førsteDigitaliseringsdato",
  SAKSAR: "saksAar",
  SAKSSEKVENSNUMMER: "saksSekvensnummer"
};
function Ye(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const a = Ve[n];
    r[a ?? n] = t;
  }
  return r;
}
function Ce(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planTypeKey: t,
    tiltakforbudType: typeof e.PBLTILTAKFORBUDTYPE == "string" ? e.PBLTILTAKFORBUDTYPE : void 0,
    informasjon: typeof e.INFORMASJON == "string" ? e.INFORMASJON : void 0,
    avgjørelsesdato: e.AVGJDATO ?? void 0,
    gyldigTilDato: e.GYLDIGTILDATO ?? void 0,
    førsteDigitaliseringsdato: e.FORSTEDIGITALISERINGSDATO ?? void 0,
    saksAar: e.SAKSAR ?? void 0,
    saksSekvensnummer: e.SAKSSEKVENSNUMMER ?? void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: Ye(n)
  };
}
function w(e) {
  const r = /* @__PURE__ */ new Map();
  for (const n of e)
    if (n.domain instanceof Ae) {
      const t = /* @__PURE__ */ new Map();
      for (const a of n.domain.codedValues)
        t.set(a.code, a.name);
      r.set(n.name, t);
    }
  return r;
}
function D(e, r) {
  const n = {};
  for (const [t, a] of Object.entries(e)) {
    const o = r.get(t);
    n[t] = o?.get(a) ?? a;
  }
  return n;
}
function ye(e) {
  return e.replace(/'/g, "''");
}
function Y(e) {
  return `'${ye(e)}'`;
}
function Or(e, r) {
  return r.length === 0 ? "1=0" : `${e} IN (${r.map(Y).join(",")})`;
}
const Je = ae("arealplan:ServicesInitializer");
function He() {
  const e = /* @__PURE__ */ new Map(), r = async (o) => {
    try {
      const s = (await de(o, {
        query: { f: "json" },
        responseType: "json"
      })).data?.layers;
      return s ? s.map((R) => ({
        id: R.id,
        name: R.name,
        url: `${o}/${R.id}`,
        geometryType: R.geometryType
      })) : [];
    } catch (i) {
      throw Je.error(`Feil ved henting av layer-info fra ${o}:`, i), new C(`Kunne ikke laste layer-info: ${i?.message ?? i}`, i);
    }
  }, n = (o) => {
    let i = e.get(o);
    return i || (i = r(o).catch((s) => {
      throw e.delete(o), s;
    }), e.set(o, i)), i;
  };
  return { getLayerInfo: n, getLayerIds: async (o, i) => {
    const s = await n(o);
    if (i && i.length > 0) {
      const R = new Set(i);
      return s.filter((m) => R.has(m.name)).map((m) => m.id);
    }
    return s.filter((R) => R.geometryType === "esriGeometryPolygon").map((R) => R.id);
  }, getLayerMap: async (o) => {
    const i = await n(o);
    return new Map(i.map((s) => [s.name, s]));
  } };
}
const We = ae("arealplan:queryFeatureLayers"), Ue = 2e3, Qe = 1e3, ze = {
  point: "esriGeometryPoint",
  multipoint: "esriGeometryMultipoint",
  polyline: "esriGeometryPolyline",
  polygon: "esriGeometryPolygon",
  extent: "esriGeometryEnvelope"
};
async function B(e, r, n) {
  return r.layerIds.length === 0 ? [] : (await Promise.all(
    r.layerIds.map((a) => Xe(e, a, r, n))
  )).filter((a) => a !== null);
}
async function Xe(e, r, n, t) {
  const a = {
    where: n.where,
    outSR: n.outputWkid,
    returnGeometry: n.returnGeometry !== !1,
    returnTrueCurves: n.returnTrueCurves ?? !1,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    geometryPrecision: 2,
    f: "json"
  };
  n.geometry && (a.geometryType = ze[n.geometry.type] ?? "esriGeometryPolygon", a.inSR = n.geometry.spatialReference?.wkid ?? n.outputWkid, a.geometry = JSON.stringify(n.geometry.toJSON()), a.spatialRel = "esriSpatialRelIntersects");
  const o = [];
  let i = null, s = 0;
  try {
    for (let m = 0; m < Qe; m++) {
      const h = (await de(`${e}/${r}/query`, {
        query: { ...a, resultOffset: s, resultRecordCount: Ue },
        method: "post",
        responseType: "json",
        signal: t?.signal
      })).data, v = h?.features ?? [];
      if (m === 0 && (i = h), o.push(...v), h?.exceededTransferLimit !== !0 || v.length === 0)
        break;
      s += v.length;
    }
  } catch (m) {
    throw t?.signal?.aborted || Ze(m) ? new J() : (We.error(`Feil ved query mot ${e}/${r}:`, m), new C(
      `Query mot ${e}/${r} feilet: ${m?.message ?? m}`,
      m
    ));
  }
  return !i || o.length === 0 ? null : { featureSet: Ne.fromJSON({ ...i, features: o }), layerId: r };
}
function Ze(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
const $ = ae("arealplan:arcgisArealplanRepository"), j = 25833;
function q(e) {
  if (e instanceof J)
    throw e;
}
function er(e) {
  if (!e.settings)
    throw new H("createArcgisArealplanRepository: settings required");
  const r = e.services ?? He(), n = () => Object.entries(e.settings.planTypes).filter(([l]) => Be.test(l)).map(([l, f]) => [l, f.url]), t = async (l, f) => {
    const k = n(), c = await Promise.all(
      k.map(async ([y, d]) => {
        try {
          const p = ee(y), E = await r.getLayerMap(d);
          let g;
          for (const u of p) {
            const b = E.get(u);
            if (b) {
              g = b;
              break;
            }
          }
          return g ? (await B(
            d,
            {
              layerIds: [g.id],
              where: "1=1",
              geometry: l,
              returnGeometry: !1,
              // `*` i stedet for en eksplisitt feltliste: per-lag
              // endepunktet `/{layerId}/query` validerer outFields
              // strengt og avviser HELE queryen om ett felt mangler
              // på laget («'outFields' parameter is invalid»). Det
              // gamle tjeneste-nivå layerDefs-endepunktet var
              // tolerant her. Mapperen plukker felt by-name
              // (WIRE_TO_DOMAIN_KEY), så ekstra felt er uskadelig.
              outputWkid: j
            },
            f
          )).flatMap(({ featureSet: u }) => {
            const b = w(u.fields ?? []);
            return u.features.map(
              (I) => le(
                I.attributes,
                y,
                D(I.attributes, b)
              )
            );
          }) : [];
        } catch (p) {
          return q(p), $.error(`Feil ved henting av planer fra ${y}:`, p), [];
        }
      })
    );
    return me(c.flat());
  }, a = (l) => t(void 0, l), o = (l, f) => t(l, f), i = async (l, f) => (await Promise.all(
    Object.entries(e.settings.planTypes).map(async ([c, y]) => {
      try {
        const d = ee(c);
        if (d.length === 0)
          return [];
        const p = await r.getLayerIds(y.url, d);
        return p.length === 0 ? [] : (await B(
          y.url,
          {
            layerIds: p,
            where: "1=1",
            geometry: l,
            outputWkid: l.spatialReference?.wkid ?? j
          },
          f
        )).map(({ featureSet: g }) => (g.features = g.features.filter(
          (A) => se(l, A.geometry ?? void 0)
        ), { planTypeKey: c, featureSet: g })).filter((g) => g.featureSet.features.length > 0);
      } catch (d) {
        return q(d), $.error(`Feil ved spatial query for ${c}:`, d), [];
      }
    })
  )).flat(), s = async (l, f) => (await i(l, f)).flatMap((c) => {
    const y = w(c.featureSet.fields ?? []);
    return c.featureSet.features.map(
      (d) => le(
        d.attributes,
        c.planTypeKey,
        D(d.attributes, y)
      )
    );
  }), R = async (l, f) => {
    const k = l.spatialReference?.wkid ?? j;
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([y, d]) => {
        try {
          const p = await r.getLayerIds(
            d.url,
            Z
          );
          return p.length === 0 ? [] : (await B(
            d.url,
            {
              layerIds: p,
              where: "1=1",
              geometry: l,
              outputWkid: k
            },
            f
          )).flatMap(({ featureSet: g }) => {
            const A = w(g.fields ?? []);
            return g.features.filter(
              (u) => se(l, u.geometry ?? void 0)
            ).map(
              (u) => re(
                u.attributes,
                u.geometry ?? void 0,
                D(u.attributes, A),
                y
              )
            );
          });
        } catch (p) {
          return q(p), $.error(`Feil ved delområde-query for ${y}:`, p), [];
        }
      })
    )).flat();
  }, m = async (l, f) => {
    if (l.length === 0)
      return [];
    const k = [], c = [], y = /* @__PURE__ */ new Map(), d = /^([^:\-]+)[:-](\d+)$/, p = /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\}?$/;
    for (const u of l) {
      const b = d.exec(u);
      if (b) {
        const I = b[1], P = Number(b[2]);
        if (Number.isFinite(P)) {
          let T = y.get(I);
          T || (T = [], y.set(I, T)), T.push(P);
          continue;
        }
      }
      if (p.test(u)) {
        c.push(u);
        continue;
      }
      k.push(u);
    }
    const E = [];
    k.length > 0 && E.push(`LOKALID IN (${k.map(Y).join(",")})`), c.length > 0 && E.push(`GlobalID IN (${c.map(Y).join(",")})`);
    for (const [u, b] of y)
      E.push(
        `(OBJTYPE = ${Y(u)} AND OBJECTID IN (${b.join(",")}))`
      );
    const g = E.join(" OR ");
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([u, b]) => {
        try {
          const I = await r.getLayerIds(
            b.url,
            Z
          );
          return I.length === 0 ? [] : (await B(
            b.url,
            {
              layerIds: I,
              where: g,
              outputWkid: j
            },
            f
          )).flatMap(({ featureSet: T }) => {
            const G = w(T.fields ?? []);
            return T.features.map(
              (z) => re(
                z.attributes,
                z.geometry ?? void 0,
                D(z.attributes, G),
                u
              )
            );
          });
        } catch (I) {
          return q(I), $.error(`Feil ved findDelområderByIds for ${u}:`, I), [];
        }
      })
    )).flat();
  }, K = async (l, f, k, c, y) => {
    const d = e.settings.planTypes[f];
    if (!d)
      return [];
    const p = await r.getLayerIds(d.url, Z);
    if (p.length === 0)
      return [];
    const E = y ?? k?.spatialReference?.wkid ?? j;
    return (await B(
      d.url,
      {
        layerIds: p,
        where: `PLANID = '${ye(l)}'`,
        geometry: k,
        outputWkid: E
      },
      c
    )).flatMap(({ featureSet: A }) => {
      const u = w(A.fields ?? []);
      return A.features.filter(
        (b) => ce(k, b.geometry ?? void 0, { minAreaM2: 1 }).keep
      ).map(
        (b) => re(
          b.attributes,
          b.geometry ?? void 0,
          D(b.attributes, u),
          f
        )
      );
    });
  }, h = async (l, f) => {
    const k = e.settings.planTypes[l.planTypeKey], c = l.objectIds ?? (l.objectId != null ? [l.objectId] : []);
    if (!k || c.length === 0)
      return null;
    const y = ee(l.planTypeKey), d = await r.getLayerMap(k.url);
    let p;
    for (const A of y) {
      const u = d.get(A);
      if (u) {
        p = u;
        break;
      }
    }
    if (!p)
      return null;
    const g = (await B(
      k.url,
      {
        layerIds: [p.id],
        where: `OBJECTID IN (${c.map(Number).join(",")})`,
        returnGeometry: !0,
        outFields: ["OBJECTID"],
        outputWkid: j
      },
      f
    )).flatMap(({ featureSet: A }) => A.features).map((A) => A.geometry).filter((A) => A != null);
    return g.length <= 1 ? g[0] ?? null : ge.executeMany(g) ?? null;
  }, v = async (l, f, k, c, y) => {
    const d = l.spatialReference?.wkid ?? j, p = Object.entries(e.settings.planTypes).filter(
      ([g]) => f.test(g)
    );
    return (await Promise.all(
      p.map(async ([g, A]) => {
        try {
          const b = (await r.getLayerInfo(A.url)).filter((P) => P.geometryType != null).map((P) => P.id);
          return b.length === 0 ? [] : (await B(
            A.url,
            {
              layerIds: b,
              where: "1=1",
              geometry: l,
              outputWkid: d
            },
            y
          )).flatMap(({ featureSet: P }) => {
            const T = w(P.fields ?? []);
            return P.features.map(
              (G) => k(
                G.attributes,
                G.geometry ?? void 0,
                D(G.attributes, T),
                g
              )
            );
          });
        } catch (u) {
          return q(u), $.error(`Feil ved ${c}-query for ${g}:`, u), [];
        }
      })
    )).flat();
  };
  return {
    findAll: a,
    findByPoint: o,
    findByPolygon: s,
    findFeaturesByPolygon: i,
    findDelområderByPolygon: R,
    findDelområderByIds: m,
    getDelområderForPlan: K,
    getGeometry: h,
    findDispensasjonerByPolygon: (l, f) => v(
      l,
      je,
      (k, c, y, d) => _e(
        k,
        c,
        y,
        d
      ),
      "dispensasjon",
      f
    ),
    findMidlertidigeForbudByPolygon: (l, f) => v(
      l,
      Le,
      (k, c, y, d) => Ce(
        k,
        c,
        y,
        d
      ),
      "midlertidig forbud",
      f
    )
  };
}
function rr(e) {
  const { kommunenummer: r, gardsnummer: n, bruksnummer: t, festenummer: a, seksjonsnummer: o } = e;
  if (n == null || t == null)
    return;
  let i = "";
  return r != null && (i += `${r}-`), i += `${n}/${t}`, a && (i += `-${a}`), o && (i += `/${o}`), i;
}
function ue(e, r) {
  return {
    objectId: e.OBJECTID,
    id: String(e.matrikkelid ?? e.OBJECTID),
    kommunenummer: e.kommunenummer != null ? Number(e.kommunenummer) : void 0,
    gardsnummer: e.gardsnummer != null ? Number(e.gardsnummer) : void 0,
    bruksnummer: e.bruksnummer != null ? Number(e.bruksnummer) : void 0,
    festenummer: e.festenummer != null ? Number(e.festenummer) : void 0,
    seksjonsnummer: e.seksjonsnummer != null ? Number(e.seksjonsnummer) : void 0,
    matrikkelId: e.matrikkelid != null ? String(e.matrikkelid) : void 0,
    matrikkelnummerTekst: e.matrikkelnummer ?? rr(e),
    geometri: r
  };
}
function nr(e) {
  if (!e.teigerUrl)
    throw new H("createArcgisTeigRepository: teigerUrl required");
  let r = null;
  const n = () => (r ?? (r = new Ee({ url: e.teigerUrl })), r), t = async (o, i) => {
    try {
      return await o();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? new J() : new C(`${i} feilet: ${s?.message ?? s}`, s);
    }
  }, a = async (o, i) => t(async () => {
    const s = n().createQuery();
    return s.where = o, s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
      (m) => ue(
        m.attributes,
        m.geometry
      )
    );
  }, "TeigRepository.query");
  return {
    findByMatrikkel: async (o, i) => {
      const s = [];
      return s.push(`gardsnummer = ${o.gardsnummer}`), s.push(`bruksnummer = ${o.bruksnummer}`), s.push(`kommunenummer = ${o.kommunenummer}`), o.festenummer != null && s.push(`festenummer = ${o.festenummer}`), o.seksjonsnummer != null && s.push(`seksjonsnummer = ${o.seksjonsnummer}`), a(s.join(" AND "), i);
    },
    findByGeometry: async (o, i) => t(async () => {
      const s = n().createQuery();
      return s.geometry = o, s.spatialRelationship = "intersects", s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
        (m) => ue(
          m.attributes,
          m.geometry
        )
      );
    }, "TeigRepository.findByGeometry")
  };
}
function Fr(e) {
  if (!e.settings)
    throw new H("createArealplanClient: settings required");
  const r = er({ settings: e.settings }), n = e.settings.teigerUrl ? nr({ teigerUrl: e.settings.teigerUrl }) : void 0;
  return { arealplaner: r, teiger: n };
}
const N = {
  all: ["arealplan"],
  list: () => ["arealplan", "list"],
  byPolygon: (e, r, n, t, a) => ["arealplan", "byPolygon", e, r, n, t, a],
  featuresByPolygon: (e, r, n, t, a) => ["arealplan", "featuresByPolygon", e, r, n, t, a],
  delområder: {
    all: ["arealplan", "delområder"],
    byPolygon: (e, r, n, t, a) => ["arealplan", "delområder", "byPolygon", e, r, n, t, a],
    byIds: (e) => ["arealplan", "delområder", "byIds", [...e].sort().join(",")],
    forPlan: (e, r, n = 0, t = 0, a = 0, o = 0, i = 0) => [
      "arealplan",
      "delområder",
      "forPlan",
      e,
      r,
      n,
      t,
      a,
      o,
      i
    ]
  },
  geometry: (e, r, n) => ["arealplan", "geometry", e, r, n.join(",")],
  teiger: {
    byMatrikkel: (e, r, n, t, a) => ["arealplan", "teiger", "matrikkel", e, r, n, t, a],
    byGeometry: (e, r, n) => ["arealplan", "teiger", "geometry", e, r, n]
  },
  dispensasjoner: {
    byPolygon: (e, r, n, t, a) => ["arealplan", "dispensasjoner", "byPolygon", e, r, n, t, a]
  },
  midlertidigeForbud: {
    byPolygon: (e, r, n, t, a) => ["arealplan", "midlertidigeForbud", "byPolygon", e, r, n, t, a]
  }
};
async function tr(e, r) {
  return e.arealplaner.findAll(r);
}
async function ar(e, r, n) {
  return e.arealplaner.findByPolygon(r.polygon, n);
}
async function or(e, r, n) {
  return e.arealplaner.findFeaturesByPolygon(r.polygon, n);
}
async function ir(e, r, n) {
  return e.arealplaner.findDelområderByPolygon(r.polygon, n);
}
async function sr(e, r, n) {
  return e.arealplaner.findDelområderByIds(r.omradeIds, n);
}
async function lr(e, r, n) {
  return e.arealplaner.getDelområderForPlan(
    r.planId,
    r.planTypeKey,
    r.polygon,
    n,
    r.outputWkid
  );
}
async function ur(e, r, n) {
  return e.arealplaner.getGeometry(r.plan, n);
}
async function dr(e, r, n) {
  return e.teiger.findByMatrikkel(r, n);
}
async function mr(e, r, n) {
  return e.teiger.findByGeometry(r.geometry, n);
}
async function cr(e, r, n) {
  return e.arealplaner.findDispensasjonerByPolygon(r.polygon, n);
}
async function yr(e, r, n) {
  return e.arealplaner.findMidlertidigeForbudByPolygon(r.polygon, n);
}
const V = 5 * 6e4, L = 6e4, fr = (e) => ({
  list: () => O({
    queryKey: N.list(),
    queryFn: ({ signal: r }) => tr(e, { signal: r }),
    staleTime: V
  }),
  byPolygon: (r) => O({
    queryKey: r ? N.byPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : N.byPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => ar(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: L
  }),
  featuresByPolygon: (r) => O({
    queryKey: r ? N.featuresByPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : N.featuresByPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => or(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: L
  }),
  delområder: {
    byPolygon: (r) => O({
      queryKey: r ? N.delområder.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.delområder.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => ir(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: L
    }),
    byIds: (r) => O({
      queryKey: N.delområder.byIds(r),
      queryFn: ({ signal: n }) => sr(e, { omradeIds: r }, { signal: n }),
      enabled: r.length > 0,
      staleTime: L
    }),
    forPlan: (r, n, t, a) => O({
      // outputWkid MÅ inn i nøkkelen — uten polygon skiller den ellers
      // ikke 25832- fra 25833-resultater, og cachen ville servert feil-SR
      // geometri til kart-rendering.
      queryKey: t ? N.delområder.forPlan(
        r ?? "",
        n ?? "",
        t.extent?.xmin ?? 0,
        t.extent?.ymin ?? 0,
        t.extent?.xmax ?? 0,
        t.extent?.ymax ?? 0,
        t.spatialReference?.wkid ?? 0
      ) : N.delområder.forPlan(
        r ?? "",
        n ?? "",
        0,
        0,
        0,
        0,
        a ?? 0
      ),
      queryFn: ({ signal: o }) => lr(
        e,
        {
          planId: r,
          planTypeKey: n,
          polygon: t ?? void 0,
          outputWkid: a
        },
        { signal: o }
      ),
      enabled: !!(r && n),
      staleTime: L
    })
  },
  geometry: (r) => O({
    queryKey: r ? N.geometry(
      r.planId,
      r.planTypeKey,
      r.objectIds ?? (r.objectId != null ? [r.objectId] : [])
    ) : N.geometry("", "", []),
    queryFn: ({ signal: n }) => ur(e, { plan: r }, { signal: n }),
    enabled: r != null,
    staleTime: V
  }),
  dispensasjoner: {
    byPolygon: (r) => O({
      queryKey: r ? N.dispensasjoner.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.dispensasjoner.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => cr(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: L
    })
  },
  midlertidigeForbud: {
    byPolygon: (r) => O({
      queryKey: r ? N.midlertidigeForbud.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.midlertidigeForbud.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => yr(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: L
    })
  },
  teiger: {
    byMatrikkel: (r) => O({
      queryKey: N.teiger.byMatrikkel(
        r?.kommunenummer ?? 0,
        r?.gardsnummer ?? 0,
        r?.bruksnummer ?? 0,
        r?.festenummer ?? 0,
        r?.seksjonsnummer ?? 0
      ),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return dr(
          { teiger: e.teiger },
          r,
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: V
    }),
    byGeometry: (r) => O({
      queryKey: r ? N.teiger.byGeometry(
        r.x ?? 0,
        r.y ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.teiger.byGeometry(0, 0, 0),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return mr(
          { teiger: e.teiger },
          { geometry: r },
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: V
    })
  }
});
function te(e, r) {
  if (e.attributter[r] != null)
    return e.attributter[r];
  const n = r.toLowerCase();
  for (const [t, a] of Object.entries(e.attributter))
    if (t.toLowerCase() === n && a != null)
      return a;
}
function fe(e, r) {
  return te(e, r) ?? e.displayValues[r];
}
function pe(e) {
  return Array.from(
    new Set(
      e.filter((r) => r != null).map((r) => String(r).trim()).filter(Boolean)
    )
  );
}
function Sr(e) {
  if (e.arealformål)
    return [e.arealformål];
  const r = _(e.objtype);
  if (!r)
    return [];
  const n = fe(e, r.typeFelt);
  return pe([n]);
}
function Pr(e) {
  const r = _(e.objtype), n = r ? fe(e, r.headingFelt) : void 0, t = e.objtype, a = e.objectId, o = te(e, "GlobalID"), i = te(e, "LOKALID"), s = o == null ? void 0 : String(o).replace(/[{}]/g, "").trim(), R = [
    n,
    i,
    o,
    s,
    s ? s.toLowerCase() : void 0,
    s ? s.toUpperCase() : void 0,
    s ? `{${s}}` : void 0,
    s ? `{${s.toUpperCase()}}` : void 0,
    a,
    t && a ? `${t}-${a}` : void 0,
    a ? `undefined-${a}` : void 0
  ];
  return pe(R);
}
const W = Oe(null), vr = ({
  client: e,
  children: r
}) => {
  const n = Fe(
    () => ({
      client: e,
      queries: fr({
        arealplaner: e.arealplaner,
        teiger: e.teiger
      })
    }),
    [e]
  );
  return /* @__PURE__ */ Ie(W.Provider, { value: n, children: r });
};
function Tr() {
  const e = oe(W);
  if (!e)
    throw new Error("useArealplanClient må brukes innenfor en <ArealplanClientProvider>");
  return e.client;
}
function hr() {
  return oe(W)?.client ?? null;
}
function S() {
  const e = oe(W);
  if (!e)
    throw new Error("useArealplanQueries må brukes innenfor en <ArealplanClientProvider>");
  return e.queries;
}
function Br() {
  const e = S();
  return F(e.list());
}
function jr(e) {
  const r = S();
  return F(r.byPolygon(e));
}
function Lr(e) {
  const r = S();
  return F(r.featuresByPolygon(e));
}
function Mr(e) {
  const r = S();
  return F(r.geometry(e));
}
function Kr(e) {
  const r = S();
  return F(r.dispensasjoner.byPolygon(e));
}
function wr(e) {
  const r = S();
  return F(r.midlertidigeForbud.byPolygon(e));
}
function Dr(e) {
  const r = S();
  return F(r.delområder.byPolygon(e));
}
function Gr(e) {
  const r = S();
  return F(r.delområder.byIds(e));
}
function xr(e, r, n, t) {
  const a = S();
  return F(a.delområder.forPlan(e, r, n, t));
}
function $r(e) {
  const r = S();
  return F(r.teiger.byMatrikkel(e));
}
function qr(e) {
  const r = S();
  return F(r.teiger.byGeometry(e));
}
class _r {
  constructor(r = {}) {
    this.data = r;
  }
  async findAll() {
    return [...this.data.arealplaner ?? []];
  }
  async findByPoint() {
    return [...this.data.arealplaner ?? []];
  }
  async findByPolygon() {
    return [...this.data.arealplaner ?? []];
  }
  async findFeaturesByPolygon() {
    return [];
  }
  async findDelområderByPolygon() {
    return [...this.data.delområder ?? []];
  }
  async findDelområderByIds(r) {
    const n = new Set(r);
    return (this.data.delområder ?? []).filter((t) => t.omradeId && n.has(t.omradeId));
  }
  async getDelområderForPlan(r) {
    return (this.data.delområder ?? []).filter((n) => n.planId === r);
  }
  async getGeometry() {
    return null;
  }
  async findDispensasjonerByPolygon() {
    return [...this.data.dispensasjoner ?? []];
  }
  async findMidlertidigeForbudByPolygon() {
    return [...this.data.midlertidigeForbud ?? []];
  }
}
class Vr {
  constructor(r = []) {
    this.teiger = r;
  }
  async findByMatrikkel(r) {
    return this.teiger.filter(
      (n) => n.kommunenummer === r.kommunenummer && n.gardsnummer === r.gardsnummer && n.bruksnummer === r.bruksnummer && (r.festenummer == null || n.festenummer === r.festenummer) && (r.seksjonsnummer == null || n.seksjonsnummer === r.seksjonsnummer)
    );
  }
  async findByGeometry() {
    return [...this.teiger];
  }
}
export {
  Z as ALL_DELOMRADE_SUBLAYER_NAMES,
  J as AbortedError,
  vr as ArealplanClientProvider,
  M as ArealplanError,
  he as AuthError,
  H as ConfigurationError,
  _r as FakeArealplanRepository,
  Vr as FakeTeigRepository,
  C as NetworkError,
  ve as NotFoundError,
  ne as OBJTYPE_REGISTRY,
  Te as ValidationError,
  le as arealplanFromAttrs,
  N as arealplanKeys,
  fr as arealplanQueries,
  w as buildFieldLookup,
  Or as buildInClause,
  er as createArcgisArealplanRepository,
  nr as createArcgisTeigRepository,
  Fr as createArealplanClient,
  re as delområdeFromFeature,
  _e as dispensasjonFromFeature,
  Ir as domain,
  ye as escapeSqlValue,
  or as findArealplanFeaturesByPolygon,
  ar as findArealplanerByPolygon,
  sr as findDelområderByIds,
  ir as findDelområderByPolygon,
  cr as findDispensasjonerByPolygon,
  yr as findMidlertidigeForbudByPolygon,
  _ as findObjtypeInfo,
  mr as findTeigByGeometry,
  dr as findTeigByMatrikkel,
  Sr as getArealformålCandidates,
  ur as getArealplanGeometry,
  Pr as getOmrådeIdCandidates,
  ee as getPlanomradeLagnavn,
  tr as loadAlleArealplaner,
  lr as loadDelområderForArealplan,
  D as mapDisplayValues,
  me as mergePlanomrader,
  Ce as midlertidigForbudFromFeature,
  Se as planKey,
  Y as qv,
  ue as teigFromAttrs,
  Tr as useArealplanClient,
  hr as useArealplanClientOptional,
  Lr as useArealplanFeaturesByPolygon,
  Mr as useArealplanGeometry,
  Br as useArealplaner,
  jr as useArealplanerByPolygon,
  Gr as useDelområderByIds,
  Dr as useDelområderByPolygon,
  xr as useDelområderForArealplan,
  Kr as useDispensasjonerByPolygon,
  wr as useMidlertidigeForbudByPolygon,
  qr as useTeigByGeometry,
  $r as useTeigByMatrikkel
};
//# sourceMappingURL=index.mjs.map
